import { Button } from 'primereact/button';
import {useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InvoiceUserModel } from '../../models/orders/order-list-model';
import UserAddressService from '../../services/useraddress/useraddress.service';
 
interface SearchPanelProps {
    onSearch: (query:any) => void;
}
 
const CashCollectionReportListSearch: React.FC<SearchPanelProps> = ({ onSearch }) => {
 
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();
    const [invoicedList,setInvoicedList] = useState<InvoiceUserModel[]>([]);
    const [searchInvoiceBy, setSearchInvoiceBy] = useState<any>(null);
    
    useEffect(() => {
     UserAddressService.getInvoiceUsers().then(r =>  setInvoicedList(r))
    }, []);

    function handleSearch(){
     var data =
      {
        userId : searchInvoiceBy,
        startDate : startDate,
        endDate : endDate
      }
      onSearch(data)
    }

    function handleReset(){
      setEndDate(null);
      setStartDate(null);
      setSearchInvoiceBy(null);
           var data =
      {
        userId : searchInvoiceBy,
        startDate : null,
        endDate : null
      }
      onSearch(data)
    }

    return (
        <div className="flex flex-column md:flex-row justify-content-between align-items-center gap-3">
            {/* Left side: Inputs */}
            <div className="flex flex-column md:flex-row align-items-center gap-3 w-full" style={{ flex: 1, maxWidth: '800px' }}>
                <span className="w-full md:w-auto flex-1">
                  <Dropdown
                    id="SearchUser"
                    name="SearchUser"                                                      
                    options={invoicedList}
                    optionLabel="displayName"
                    optionValue="userID"
                    value={searchInvoiceBy}
                    onChange={(e) => setSearchInvoiceBy(e.target.value)}
                    filter
                    placeholder="Invoice By"
                    className="w-full"
                    style={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #d1d5db'
                    }}
                  />
                </span>
                
                <span className="w-full md:w-auto flex-1 flex gap-2">
                 <Calendar value={startDate} onChange={(e) => setStartDate(e.value)}
                  dateFormat="dd/mm/yy" className="w-full"
                  placeholder="start date"
                  inputStyle={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db'
                  }} />
                 <Calendar value={endDate} onChange={(e) => setEndDate(e.value)}
                  dateFormat="dd/mm/yy" className="w-full"
                  placeholder="end date"
                  inputStyle={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db'
                  }} />
                </span>
            </div>

            {/* Right side: Buttons */}
            <div className="flex align-items-center gap-2 w-full md:w-auto">
                <Button className="p-button-success flex-1 md:flex-none px-4" label="Filter" onClick={handleSearch} style={{ borderRadius: '8px', background: '#0e6f3b', border: 'none' }}></Button>
                <Button className="flex-1 md:flex-none px-4" raised label="Reset" onClick={handleReset} style={{ backgroundColor: '#547180', color: 'white', border: 'none', borderRadius: '8px' }}></Button>
            </div>
        </div>
    );
};

export default CashCollectionReportListSearch;
